import Vue from 'vue'
Vue.prototype.$lstore=store

const utils = {
  getItem(key){
    return JSON.parse(localStorage.getItem(key))
  },
  setItem(key,obj){
    localStorage.setItem(key,JSON.stringify(obj))
  }
}
// 获取momes组件 momes
function getMomes(self){
  var pon = self.$parent
  if(typeof (pon) != "undefined" ){
    if("momes" != pon.$options.name){
      return getMomes(pon)
    }else{
      return pon
    }
  }else{
    return null
  }
}

function setStoreTabStatus(type,self){
  store.topBarStatus.set(type)
  getMomes(self).$refs.itchild.$refs.ntchild.commonTopBarStatus = type
}

const store = {
  topBarStatus : { // 首页模块选择栏
    key : 'topBarStatus',
    set(obj){
      utils.setItem(this.key,obj);
    },
    get(){
      return utils.getItem(this.key)
    }
  },
  switchTopTab(){
    let tab = {
      toIndex : function(self){
        setStoreTabStatus(1,self)
      },
      toCourse : function(self){
        setStoreTabStatus(2,self)
      },
      toStudy : function(self){
        setStoreTabStatus(3,self)
      },
      toInformation : function(self){
        setStoreTabStatus(4,self)
      },
      toCentral : function(self){
        setStoreTabStatus(5,self)
      },
    }
    return tab
  }
}
export  default  store



// WEBPACK FOOTER //
// ./src/uitlis/store.js